// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"f32f99d5","115":"a4ac16b7","126":"35fb9ada","155":"6d877ade","188":"b67b5199","198":"f6e93d52","280":"f3abbea7","380":"e1021760","414":"33e99b25","513":"30ded517","640":"4faf0229","641":"1763223b","721":"09390735","775":"a23fd3d0","823":"87c4f184","970":"84deb8b5"}[chunkId] + ".chunk.js";
};